import styled from 'styled-components';
import { vars } from '$util/theme';

export default styled.span`
  &.fixter-preloader {
    position: relative;
    min-width: 8px;
    min-height: 8px;
    display: block;
    margin: 0 auto;
    line-height: 1;

    > img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .fixter-preloader_icon {
    animation: spinning 2s ease-in 0s infinite normal forwards;
    -webkit-animation: spinning 2s ease-in 0s infinite normal forwards;
    -moz-animation: spinning 2s ease-in 0s infinite normal forwards;
  }

  @keyframes spinning {
    0% {
      transform: rotateZ(0deg);
      -webkit-transform: rotateZ(0deg);
      -moz-transform: rotateZ(0deg);
      animation-timing-function: linear;
      -webkit-animation-timing-function: linear;
      -moz-animation-timing-function: linear;
    }
    100% {
      transform: rotateZ(360deg);
      -webkit-transform: rotateZ(360deg);
      -moz-transform: rotateZ(360deg);
      animation-timing-function: linear;
      -webkit-animation-timing-function: linear;
      -moz-animation-timing-function: linear;
    }
  }

  @-webkit-keyframes spinning {
    0% {
      -webkit-transform: rotateZ(0deg);
      -webkit-animation-timing-function: linear;
    }
    100% {
      -webkit-transform: rotateZ(360deg);
      -webkit-animation-timing-function: linear;
    }
  }

  @-moz-keyframes spinning {
    0% {
      -moz-transform: rotateZ(0deg);
      -moz-animation-timing-function: linear;
    }
    100% {
      -moz-transform: rotateZ(360deg);
      -moz-animation-timing-function: linear;
    }
  }
`;

export const DotsFlashingStyled = styled.span`
  width: 50px;
  height: 14px;
`;

export interface DotFlashingProps {
  readonly mode?: 'default' | 'primary' | 'success';
}

const dotFlashingColor = ({ mode = 'default' }: DotFlashingProps) =>
  mode === 'success' ? vars.quantumverse.reskinColors.yellow200 : vars.quantumverse.reskinColors.purple500;

const dotFlashingAnimation = ({ mode = 'default' }: DotFlashingProps) =>
  mode === 'success' ? 'dotFlashingGreen' : 'dotFlashingBlue';

export const DotFlashing = styled.span<DotFlashingProps>`
  display: inline-block;
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${dotFlashingColor};
  color: ${dotFlashingColor};
  animation: ${dotFlashingAnimation} 1s infinite linear alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${dotFlashingColor};
    color: ${dotFlashingColor};
    animation: ${dotFlashingAnimation} 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${dotFlashingColor};
    color: ${dotFlashingColor};
    animation: ${dotFlashingAnimation} 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashingBlue {
    0% {
      background-color: ${vars.quantumverse.reskinColors.purple500};
    }
    50%,
    100% {
      background-color: #fff;
    }
  }

  @keyframes dotFlashingGreen {
    0% {
      background-color: ${vars.quantumverse.reskinColors.yellow200};
    }
    50%,
    100% {
      background-color: #fff;
    }
  }
`;
